/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Select, SelectItem } from 'carbon-addons-iot-react';
import sortBy from 'lodash/sortBy';
import omit from 'lodash/omit';

import { Card, CardOnChangeType } from '../../types/dashboardTypes';

import { EntityTypesType } from 'EntitiesTypes';

const messages = defineMessages({ dataSource: 'Data source' });

const CustomTableCardEditContent = ({
  card,
  onChange,
  selectedDataType,
  entityTypes,
}: {
  card: Card;
  onChange: CardOnChangeType;
  selectedDataType: string;
  entityTypes: EntityTypesType;
}): JSX.Element => {
  const { formatMessage } = useIntl();
  return (
    <div className="custom-table-card-edit-selector">
      <Select
        labelText={formatMessage(messages.dataSource)}
        light
        key={selectedDataType} // have to regen if we rerender with new defaultValue
        onChange={(event): void => {
          const updatedCard = {
            // if they change the data type, clear the card current column selections
            ...card,
            content: {},
            dataSource: {
              ...omit(card.dataSource, 'attributes', 'groupBy'),
              type: event.currentTarget.value,
            },
          };
          onChange(updatedCard);
        }}
        id="datatype-card-selector"
        defaultValue={selectedDataType}>
        {sortBy(entityTypes, 'name').map(entityType => (
          <SelectItem key={entityType.name} value={entityType.name} text={entityType.name} />
        ))}
      </Select>
    </div>
  );
};

export default CustomTableCardEditContent;
